import { theme } from '../../../Assets/Styles/theme'

export const calendarStyles = {
  container: {
    width: 'fit-content',
    fontFamily: 'sans-serif',
    backgroundColor: 'white',
    borderRadius: 4,
    boxShadow: '0px 2px 10px 0px rgba(39, 55, 84, 0.08)',
  },
  header: {
    fontSize: 18,
    padding: '16px 24px',
    color: 'white',
    backgroundColor: theme.colors.primary,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  calendarGrid: {
    display: 'flex',
    flexDirection: 'column',
    padding: 6,
  },
  headerRow: {
    display: 'flex',
    marginTop: 8,
  },
  weekNumberHeader: {
    width: 44,
    height: 22,
    marginRight: 6,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  dayHeader: {
    width: 32,
    margin: '2px 4px',
    textAlign: 'center',
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.60)',
    fontSize: 12,
  },
  weekRow: {
    display: 'flex',
    alignItems: 'center',
  },
  weekNumberCell: {
    width: 44,
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontWeight: 500,
    background: 'transparent',
    marginRight: 6,
  },
  weekNumberCellSelected: {
    background: theme.colors.primary,
    color: '#fff',
    borderRadius: '50%',
  },
  weekNumberCellDisabled: {
    color: '#bbb',
    cursor: 'not-allowed',
    background: 'transparent',
  },
  dateCell: {
    height: 32,
    width: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: 'transparent',
  },
  dateCellAllowed: {
    color: '#222',
    zIndex: 999,
  },
  highlightedCell: {
    width: '40px',
    height: '40px',
    position: 'absolute',
  },
  dateCellSelected: {
    background: theme.colors.primary,
    color: '#fff',
    borderRadius: '50%',
  },
  dateCellDisabled: {
    color: '#bbb',
    cursor: 'not-allowed',
  },
  dateCellToday: {
    border: '1px solid black',
    borderRadius: '50%',
  },
  selectedDatesContainer: {
    marginTop: 16,
  },
}

export const combineStyles = (...styleObjects) => {
  return Object.assign({}, ...styleObjects)
}
